import React from "react";
import {
  Box,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Chip,
  Stack,
} from "@mui/material";
import {
  CalendarMonth,
  Instagram,
  YouTube,
  Facebook,
  Twitter,
  Language,
  Bolt,
} from "@mui/icons-material";

import trackImage from "../Assets/Img/Rectangle 21.png";
import PremiumButton from "./PremiumButton";

const dummyData = Array(3).fill({
  title: "Glow Beyond",
  brand: "Nykaa",
  date: "20 Jul, 2024 - 20 Sept, 2024",
  product: "Nykaa’s New Sustainable Skincare Line",
  budget: "20,000 – 50,000",
  image: trackImage,
  deliverables: [
    <Instagram key="ig" color="primary" />,
    <YouTube key="yt" color="error" />,
    <Facebook key="fb" color="primary" />,
    <Twitter key="tw" color="primary" />,
    <Language key="web" sx={{ color: "green" }} />,
    <Bolt key="bolt" sx={{ color: "goldenrod" }} />,
  ],
});

const Track = () => {
  const [isLocked, setIsLocked] = React.useState(true);

  return (
    <Box position="relative" p={4}>
      <Typography
        variant="h5"
        fontWeight="300"
        mb={3}
        color="#0B0B0B"
        sx={{
          fontFamily: "Poppins, sans-serif",
          filter: "blur(3px)", // 👈 blur added here
        }}
      >
        Completed Campaign
      </Typography>

      <Box
        sx={{
          filter: isLocked ? "blur(8px)" : "none",
          pointerEvents: isLocked ? "none" : "auto",
        }}
      >
        <Grid container spacing={3}>
          {dummyData.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ borderRadius: 3, position: "relative" }}>
                <CardMedia
                  component="img"
                  loading="lazy"
                  height="250"
                  image={card.image}
                  alt={card.title}
                  sx={{ borderTopLeftRadius: 12, borderTopRightRadius: 12,  }}
                />
                <Chip
                  label="Completed"
                  size="small"
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    backgroundColor: "#ECECEC",
                    fontWeight: "bold",
                  }}
                />
                <CardContent>
                  <Typography fontWeight="bold">{card.title}</Typography>
                  <Typography color="text.secondary" fontSize="14px" mb={1}>
                    {card.brand}
                  </Typography>
                  <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <CalendarMonth fontSize="small" />
                    <Typography fontSize="13px">{card.date}</Typography>
                  </Stack>
                  <Typography fontWeight="bold" fontSize="14px" mb={0.5}>
                    Product
                  </Typography>
                  <Typography fontSize="13px" mb={1}>
                    {card.product}
                  </Typography>
                  <Typography fontWeight="bold" fontSize="14px" mb={0.5}>
                    Budget
                  </Typography>
                  <Typography fontSize="13px" mb={1}>
                    {card.budget}
                  </Typography>
                  <Typography fontWeight="bold" fontSize="14px" mb={0.5}>
                    Deliverables
                  </Typography>
                  <Stack direction="row" spacing={1} mb={2}>
                    {card.deliverables}
                  </Stack>
                  <Button
                    fullWidth
                    variant="outlined"
                    sx={{
                      textTransform: "none",
                      borderRadius: 2,
                      fontWeight: 500,
                      color: "#4C5C4C",
                      borderColor: "#4C5C4C",
                    }}
                  >
                    Add Deliverables Link
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Overlay */}
      {isLocked && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 0,
            width: "100%",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "rgba(0, 0, 0, 0.6)",
            color: "white",
            textAlign: "center",
            // px: 2,
          }}
        >
          <Typography variant="h6" fontWeight="bold" mt={1}>
            Subscribe to Use This Feature
          </Typography>
          <Typography variant="body2" mt={3}>
            You Have to Upgrade Your Plan to Use This Feature
          </Typography>

          {/* <Button
            variant="contained"
            sx={{
              background: "linear-gradient(90deg, #FFDD55, #FFD522)",
              color: "black",
              fontWeight: "bold",
              borderRadius: 2,
              px: 4,
            }}
          >
            Upgrade
          </Button> */}
          <PremiumButton />
        </Box>
      )}
    </Box>
  );
};

export default Track;
